//  IMPORTANT:
//  This file is generated. Your changes will be lost.
//  Source Table: [dbo].[Flag]

export enum FlagEnum {
  CanImpersonateUsers = 1,
  CanEditAllProjects = 2
}
